import { authApiCall } from '../auth/saga';


export const getPaymentMethodsApi = () =>
  authApiCall({
    url: '/payment/payment-methods/',
    method: 'get',
  });

export const subscribeApi = (payload) =>
  authApiCall({
    url: '/payment/subscribe/',
    method: 'post',
    data: payload,
  });

export const checkoutApi = (payload) =>
  authApiCall({
    url: '/payment/checkout/',
    method: 'post',
    data: payload,
  });

export const validatePromoCodeApi = (payload) =>
  authApiCall({
    url: '/payment/validate-promo/',
    method: 'post',
    data: payload,
  });
